export default __webpack_public_path__ + "static/media/weather.4e75578e.svg";